// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-checkbox .custom-control-label[data-v-459c9106]::before {\n    border-radius: .50rem!important;cursor: pointer;\n}\n.no-image-gallery i.far[data-v-459c9106] {\n  font-size: 42px;\n  color: #959595;\n}\n\n", ""]);
// Exports
module.exports = exports;
